<template>
  <v-card
    elevation="0"
    class="text-center pa-4"
    width="100%"
    color="background2"
  >
    <v-card-title class="justify-center primary--text">
      Seus pontos
    </v-card-title>
    <v-card-text
      class="headline text-center"
      style="cursor:default"
    >
      35 pts
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    name: 'AvbYourPoints',
    data: () => {
        return{

        }
    }
}
</script>

<style>

</style>
